import PreviewContact from '../sections/PreviewContact';
import PreviewCareer from '../sections/PreviewCareer';
import PreviewExpertise from '../sections/PreviewExpertise';
import PreviewWork from '../sections/PreviewWork';
import PreviewEducation from '../sections/PreviewEducation';
import PreviewComputerSkills from '../sections/PreviewComputerSkills';
import PreviewVolunteer from '../sections/PreviewVolunteer';
import PreviewLicenses from '../sections/PreviewLicenses';
import PreviewAwards from '../sections/PreviewAwards';
import PreviewLanguages from '../sections/PreviewLanguages';
import PreviewAcademic from '../sections/PreviewAcademic';
import PreviewExtra from '../sections/PreviewExtra';
import RSAccordion from './RSAccordion';
import RSFlat from './RSFlat';
import {
  Box
} from '@chakra-ui/react';
import { useState } from 'react';

const Sections = ({myData,props,previews,styles,isDesktop }) => {
  //This is for toggling all of the accordions at once.  currently deprecated.
  const [isAccordion, setIsAccordion] = useState(true);
  const PreviewDisplay = isAccordion ? RSAccordion : RSFlat;
  const style = {...styles.accordion, ...styles.section};
  return (

    <Box sx={{...style}}  padding='0 1rem' >
      <PreviewContact props={props} savedResume={myData}  isDesktop={isDesktop[0]} />

      <PreviewDisplay  myData={myData} props={props} previews={previews} sectionName="download">
        <PreviewCareer myData={myData} props={props}/>
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews} sectionName="technical-skills">
        <PreviewExpertise questions={previews['technical-skills'].questions[0]} />
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews}  sectionName="professional-experience">
        <PreviewWork items={myData['professional-experience']}  props={props}  />
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews} sectionName="education">
        <PreviewEducation items={myData['education']} />
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews} sectionName="computer-skills">
        <PreviewComputerSkills previews={previews} />
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews}  sectionName="volunteer-experience">
        <PreviewVolunteer items={myData['volunteer-experience']} />
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews} sectionName="licenses-certifications">
        <PreviewLicenses items={myData['licenses-certifications']} />
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews} sectionName="awards-recognitions">
        <PreviewAwards items={myData['awards-recognitions']}/>
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews} sectionName="languages">
        <PreviewLanguages items={myData['languages']} />
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews}  sectionName="academic-projects">
        <PreviewAcademic items={myData['academic-projects']}/>
      </PreviewDisplay>

      <PreviewDisplay myData={myData} props={props} previews={previews} sectionName="extracurricular-activities">
        <PreviewExtra items={myData['extracurricular-activities']} />
      </PreviewDisplay>
    </Box>
  );
};
export default Sections;